import { useMemo } from "react";
import { Delete as DeleteIcon } from '@mui/icons-material';
import { Button, Checkbox, FormControlLabel, Grid, IconButton } from "@mui/material";

import { useGetUsers } from "../../../../shared/hooks";
import { FieldControl } from "../../../../shared/components";

export const Attendees = ({ meetingData, onChange, onChangeExternalAttendee, deleteExternalAttendee, addExternalAttendee, errors = {} }: { meetingData: any, onChange: (key: string, value: any) => void, onChangeExternalAttendee: (id: number, key: string, value: string) => void, deleteExternalAttendee: (id: number) => void, addExternalAttendee: () => void, errors?: { [key: string]: string } }) => {

    const { data: usersData, isLoading: isLoadingUsers } = useGetUsers();
    const userOptions = useMemo(() => {
        if (!usersData?.data) return [];
        return usersData.data.filter((u) => u.is_active === "1").map((u) => ({
            id: u.user_id,
            name: u.full_name
        }));
    }, [usersData]);

    return (
        <Grid container spacing={2}>

            <Grid size={12}>
                <FieldControl
                    keyName="attendees"
                    label="Attendees"
                    variant="select"
                    value={meetingData.attendees}
                    options={userOptions.map((user) => ({
                        value: user.id,
                        label: user.name,
                    }))}
                    loading={isLoadingUsers}
                    onChange={onChange}
                    multiSelect
                    error={!!errors.attendees}
                    helperText={errors.attendees}
                    required
                />
            </Grid>

            <Grid size={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={meetingData.allowExternal}
                            onChange={e => onChange("allowExternal", e.target.checked)}
                        />
                    }
                    label="Allow External Attendees"
                />
            </Grid>

            {meetingData.allowExternal && (
                <Grid size={12}>
                    {meetingData.externalAttendees && meetingData.externalAttendees.map((ext: { name: string; email: string; }, id: number) => (
                        <Grid container spacing={2} key={id} sx={{ mb: 2, alignItems: 'flex-start' }}>
                            <Grid size={5}>
                                <FieldControl
                                    keyName={`external_name_${id}`}
                                    label="Full Name"
                                    variant="input"
                                    onChange={(_, value) => onChangeExternalAttendee(id, 'name', value)}
                                    value={ext.name}
                                    error={!!errors[`external_name_${id}`]}
                                    helperText={errors[`external_name_${id}`]}
                                    required
                                />
                            </Grid>
                            <Grid size={6}>
                                <FieldControl
                                    keyName={`external_email_${id}`}
                                    label="Email Address"
                                    variant={"input"}
                                    onChange={(_, value) => onChangeExternalAttendee(id, 'email', value)}
                                    value={ext.email}
                                    error={!!errors[`external_email_${id}`]}
                                    helperText={errors[`external_email_${id}`]}
                                    required
                                />
                            </Grid>
                            <Grid size={1} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '56px', mt: 1 }}>
                                <IconButton
                                    onClick={() => deleteExternalAttendee(id)}
                                    color="error"
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    ))}
                    <Button
                        onClick={addExternalAttendee}
                        variant="contained"
                    >
                        Add New External User
                    </Button>
                </Grid>
            )}

        </Grid>
    )
}